// tslint:disable
export var DebitCardOrderType;
(function (DebitCardOrderType) {
    // New Card
    DebitCardOrderType[DebitCardOrderType["NEW"] = 1] = "NEW";
    // Lost/Replacement Card
    DebitCardOrderType[DebitCardOrderType["LOST"] = 2] = "LOST";
    // Expired/Replacement Card
    DebitCardOrderType[DebitCardOrderType["EXPIRED"] = 3] = "EXPIRED";
    // Rep Card
    DebitCardOrderType[DebitCardOrderType["REP"] = 4] = "REP";
    // Cards for a full batch
    DebitCardOrderType[DebitCardOrderType["BATCH"] = 5] = "BATCH";
    // Replacement Card
    DebitCardOrderType[DebitCardOrderType["REPLACE"] = 7] = "REPLACE";
})(DebitCardOrderType || (DebitCardOrderType = {}));
//# sourceMappingURL=DebitCardOrderType.js.map